import Track from 'track/Track.js';
import BaseAction from './BaseAction.js';

let counter=0;
class UpdateStepParameterAction extends BaseAction {
    constructor(sequencerEngine) {
        super(sequencerEngine);
    }

    // stepNumber can be a floating value, indicating
    // the unquantized offset
    // Any mutation of the step pattern for any track
    // which requires adding a step must come through here
    execute({track, step, parameter, value}, updateRedux=true, isSyncedOperation=false) {
        let previousValue = parameter.get();
        parameter.set(value);
        if (updateRedux) {
            if (isSyncedOperation) {
                counter++;
                let c = counter;
                setTimeout(() => {
                    if (c === counter) {
                        track.updateSteps();
                    }
                }, 50);
            } else {
                track.updateSteps();
            }
        }
        return {
            previousValue: previousValue
        };
    }


    get state() {
        return this.sequencerEngine.store.getState();
    }

    undo({payload}) {
        this.execute({... payload, value: payload.savedValue});
    }

    serialize(action, id) {
        let json = super.serialize(action, id);
        let {operation} = json;
        operation.payload.step = operation.payload.step.id;
        operation.payload.parameter = operation.payload.parameter.name;
        return json;
   }

    deserialize(json) {
        let action = super.deserialize(json);
        let payload = action.payload;
        let track = payload.track;
        if (track === undefined) {
            // no track found
            return undefined;
        }

        payload.step = this.getStepsForStepNumbers([{id: payload.step}], track)[0];
        if (payload.step === undefined) {
            return undefined;
        }
        payload.parameter = payload.step.parameters.find(
            p => p.name === payload.parameter);
        return action;
    }

    getContentId(action) {
        return [action.payload.parameter.id, action.payload.step.id];
    }
}


export default UpdateStepParameterAction;
